import { Action } from '@ngrx/store';
import { Parameter } from '../../_models/parameter';

export enum ParameterActitonTypes {

  ClearParameter = '[Parameter] Clear',
  InicializeParameter = '[Parameter] Inicialize',

  GetCurrentParameter = '[Parameter] Get Current',
  SetCurrentParameter = '[Parameter] Set Current',

	LoadParameters = '[Parameter] Get List',
	LoadParametersSuccess = '[Parameter] Load Success',
  LoadParametersFail = '[Parameter] Load Fail',

  UpdateParameter = '[Parameter] Update',
  UpdateParameterSuccess = '[Parameter] Update Success',
  UpdateParameterFail = '[Parameter] Update Fail',
}

export class ClearParameter implements Action {
	readonly type = ParameterActitonTypes.ClearParameter;
}

export class InicializeParameter implements Action {
	readonly type = ParameterActitonTypes.InicializeParameter;
}

export class GetCurrentParameter implements Action {
	readonly type = ParameterActitonTypes.GetCurrentParameter;
}

export class SetCurrentParameter implements Action {
	readonly type = ParameterActitonTypes.SetCurrentParameter;

	constructor(public payload: Parameter) {}
}

export class LoadParameters implements Action {
	readonly type = ParameterActitonTypes.LoadParameters;

	constructor(public payload: any) {}
}

export class LoadParametersSuccess implements Action {
	readonly type = ParameterActitonTypes.LoadParametersSuccess;

	constructor(public payload: Parameter[]) {}
}

export class LoadParametersFail implements Action {
	readonly type = ParameterActitonTypes.LoadParametersFail;

	constructor(public payload: string) {}
}

export class UpdateParameter implements Action {
	readonly type = ParameterActitonTypes.UpdateParameter;

	constructor(public payload: Parameter) {}
}

export class UpdateParameterSuccess implements Action {
	readonly type = ParameterActitonTypes.UpdateParameterSuccess;

	constructor(public payload: Parameter) {}
}

export class UpdateParameterFail implements Action {
	readonly type = ParameterActitonTypes.UpdateParameterFail;

	constructor(public payload: string) {}
}

// Unión de acciones
export type ParameterActions = ClearParameter
| InicializeParameter
| GetCurrentParameter
| SetCurrentParameter
| LoadParameters
| LoadParametersSuccess
| LoadParametersFail
| UpdateParameter
| UpdateParameterSuccess
| UpdateParameterFail;
